import React from 'react';
import Dialog from './Dialog';

export default (props) => {
  return <Dialog {...props} />;
};
